import Image from "../../../../../shared/components/other/Image/Image"
import { useState } from "react"
import RegInfoModal from "./RegInfoModal"
import useManageRequest from "../hooks/useManageRequest"
import useDeleteRequest from "../hooks/useDeleteRequest"
import { dialogNotify } from "../../../../../shared/services/Notifications/NotificationServices"

export interface Request {
    user?: {
        callsign: string,
        username: string,
        avatar?: string,
        main_spec?: string
    },
    team?: {
        slug: string,
        name: string,
        avatar_link: string
    },
    users?: {
        callsign: string,
        username: string,
        avatar?: string,
        main_spec?: string
    }[]
    registration_type: "team" | "user",
    registration_status: "pending" | 'approved' | 'rejected',
    processed_at?: string,
    desired_event_party: string
}

interface RequestCardProps {
    requestData: Request
    eventSlug?: string
    canDelete?: boolean
}

export default function RequestCard({
    requestData,
    eventSlug,
    canDelete = true
}: RequestCardProps) {
    const { mutate: manageMutate } = useManageRequest(eventSlug)
    const { mutate: deleteMutate } = useDeleteRequest(eventSlug)

    const [isRegInfoModal, setRegInfoModal] = useState(false)
    const [isMobile] = useState(window.innerWidth <= 768)

    const type = requestData?.registration_type
    const canOpenRegInfo = type === 'team'

    let avatar

    if (type === 'user') avatar = requestData?.user?.avatar
    if (type === 'team') avatar = requestData?.team?.avatar_link

    const isApproved = requestData.registration_status === 'approved'

    const openProfile = (username?: string) => {
        if (!username) return

        window.open(`/cabinet/${username}`)
    }

    const toManage = (status: string) => {
        if (type === 'user') {
            manageMutate({
                status,
                username: requestData.user?.username
            })
        }

        if (type === 'team') {
            requestData.users?.map(item => item.username).forEach(item =>
                manageMutate({
                    status,
                    username: item
                })
            )
        }
    }

    const confirmManage = (status: 'approved' | 'rejected') => {
        if (status === 'approved') {
            toManage(status)
            return
        }

        dialogNotify({
            status: 'info',
            title: 'Отклонение регистрации',
            description: 'Вы уверены, что хотите отклонить заявку?',
            acceptText: 'Отклонить',
            rejectText: 'Отмена',
            acceptHandler: () => toManage(status)
        })
    }

    const confirmDelete = () => {
        dialogNotify({
            status: 'info',
            title: 'Удаление регистрации',
            description: 'Вы уверены, что хотите удалить регистрацию?',
            acceptText: 'Удалить',
            rejectText: 'Отмена',
            acceptHandler: () => {
                if (type === 'user') deleteMutate(requestData?.user?.username)
                if (type === 'team') {
                    requestData?.users?.map(item => item.username).forEach(user =>
                        deleteMutate(user)
                    )
                }
            }
        })
    }

    const manageButton = isApproved ?
        <div className="eventManagementModal__requestCard_buttons">
            {canDelete && (
                <button
                    className="eventManagementModal__requestCard_buttons-deleteText"
                    onClick={(e) => {
                        e.stopPropagation()
                        confirmDelete()
                    }}
                >
                    Удалить
                </button>
            )}
        </div> :
        <div className="eventManagementModal__requestCard_buttons">
            <button
                className="eventManagementModal__requestCard_buttons-accept"
                onClick={(e) => {
                    e.stopPropagation()
                    confirmManage('approved')
                }}
            >
                Принять
            </button>
            <button
                className="eventManagementModal__requestCard_buttons-reject"
                onClick={(e) => {
                    e.stopPropagation()
                    confirmManage('rejected')
                }}
            >
                Отклонить
            </button>
        </div>


    return (
        <>
            <div className={`eventManagementModal__requestCard ${!canOpenRegInfo ? 'nonClickable' : ''}`} onClick={() => canOpenRegInfo && setRegInfoModal(true)}>
                <div className="eventManagementModal__requestCard-mainContainer">
                    {!isMobile && <div
                        className="eventManagementModal__requestCard-regType"
                    >
                        {type === 'user' ?
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 0.0898438C7.57372 0.0899995 8.84947 1.50763 8.84961 3.71191C8.84944 5.47138 7.55891 7.37812 7.55176 7.38867C7.50413 7.53898 7.48242 7.6979 7.48242 7.85645V8.19141C7.48242 8.60863 7.70176 8.98992 8.0459 9.16504L10.1084 10.0977C10.587 10.3406 10.929 10.8266 11.0244 11.3994L11.1299 12.9102H0.871094L0.976562 11.3994C1.07079 10.8263 1.41363 10.3405 1.89258 10.0977L3.95312 9.16504C4.29685 8.98997 4.51953 8.60872 4.51953 8.19141V7.85645C4.51953 7.6979 4.49571 7.53898 4.44922 7.38867C4.43991 7.37493 3.15153 5.4699 3.15137 3.71191C3.15151 1.50769 4.42689 0.0900312 6 0.0898438Z" fill="#F7F8F8" />
                            </svg> :
                            <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.41861 9.10589C5.40762 8.98181 5.40657 8.85947 5.40657 8.7343C5.40657 8.60241 5.42606 8.47241 5.4651 8.34876C5.4651 8.34876 6.0899 7.42421 6.38538 6.33794C6.06178 5.58333 5.76803 4.64422 5.76803 3.7133C5.76803 3.49707 5.78238 3.28782 5.80247 3.08169C5.38079 2.59343 4.81106 2.31693 4.18167 2.31693C2.88216 2.31693 1.82767 3.48879 1.82767 5.30999C1.82767 6.7672 2.90056 8.34871 2.90056 8.34871C2.93841 8.47237 2.95795 8.60237 2.95795 8.73426V9.01137C2.95795 9.35698 2.77549 9.67151 2.49092 9.81546L0.787507 10.5846C0.391606 10.7863 0.109901 11.1883 0.0313229 11.6614L0.00205817 12.0755C-0.0128496 12.2911 0.0536846 12.5035 0.18679 12.6614C0.319307 12.8206 0.505801 12.91 0.701438 12.91H3.48574C3.582 11.5428 3.51536 10.048 4.96536 9.31007L5.41861 9.10589Z" fill="#F7F8F8" />
                                <path d="M18.7687 11.6614C18.6907 11.1883 18.409 10.7863 18.0131 10.5846L16.3086 9.81546C16.024 9.67151 15.8427 9.35698 15.8427 9.01137V8.73426C15.8427 8.60237 15.8616 8.47237 15.9006 8.34871C15.9006 8.34871 16.9729 6.7672 16.9729 5.30999C16.9729 3.48879 15.919 2.31693 14.6172 2.31693C13.989 2.31693 13.4192 2.59343 12.9964 3.08295C13.0171 3.28843 13.0314 3.49703 13.0314 3.71326C13.0314 4.64353 12.7382 5.58268 12.4152 6.33725C12.7101 7.42352 13.336 8.34871 13.336 8.34871C13.3739 8.47237 13.394 8.60237 13.394 8.73426C13.394 8.85957 13.3923 8.98174 13.3813 9.10585L13.8036 9.29611C15.2799 10.0424 15.2163 11.52 15.3137 12.91H18.0991C18.2948 12.91 18.4812 12.8206 18.6132 12.6614C18.7463 12.5035 18.8129 12.2911 18.7979 12.0755L18.7687 11.6614Z" fill="#F7F8F8" />
                                <path d="M13.5076 10.097L11.4456 9.16547C11.1014 8.99043 10.8817 8.60995 10.8817 8.19271V7.85664C10.8817 7.69811 10.9046 7.5402 10.9523 7.38992C10.9523 7.38992 12.2489 5.4774 12.2489 3.71326C12.2489 1.50903 10.9735 0.0917969 9.39976 0.0917969C7.82658 0.0917969 6.55061 1.50907 6.55061 3.71326C6.55061 5.4774 7.84839 7.38992 7.84839 7.38992C7.89488 7.5402 7.91897 7.69811 7.91897 7.85664V8.19271C7.91897 8.60995 7.69752 8.99043 7.35383 9.16547L5.29186 10.097C4.81279 10.3398 4.47142 10.8268 4.37734 11.4001L4.27119 12.9099H14.5283L14.4233 11.4001C14.3281 10.8269 13.9867 10.3399 13.5076 10.097Z" fill="#F7F8F8" />
                            </svg>
                        }
                    </div>}
                    <div className="eventManagementModal__requestCard-container">
                        <div className="eventManagementModal__requestCard-applicantInfo">
                            {avatar ? <Image resolution={type === 'user' ? "avatar" : 'team_avatar'} src={avatar} sizes='62px'/>
                                : <img src='/no_photo.svg' />}
                            {!isMobile && type === 'team' && ((<a onClick={() => window.open(`/team/${requestData.team?.slug}`)}>{requestData?.team?.name}</a>))}
                            <div className="eventManagementModal__requestCard-applicantInfo-nameInfo">
                                {type === 'user' && (
                                    <button
                                        type="button"
                                        className="eventManagementModal__requestCard-callsignLink"
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            openProfile(requestData?.user?.username)
                                        }}
                                    >
                                        {requestData?.user?.callsign}
                                    </button>
                                )}
                                {isMobile && type === 'team' && (<h1>{requestData?.team?.name}</h1>)}
                                {isMobile && <div className="eventManagementModal__requestCard-regInfo">
                                    <p>{'Желаемая сторона: ' + requestData.desired_event_party}</p>
                                    {type === 'team' && (<p>{'Участников: ' + requestData?.users?.length}</p>)}
                                </div>}
                                {isMobile && manageButton}
                            </div>
                        </div>
                        {!isMobile && <div className="eventManagementModal__requestCard-regInfo">
                            <p>{'Желаемая сторона: ' + requestData.desired_event_party}</p>
                            {type === 'team' && (<p>{'Участников: ' + requestData?.users?.length}</p>)}
                        </div>}
                    </div>
                </div>
                {!isMobile && manageButton}
            </div>
            <RegInfoModal
                isOpen={canOpenRegInfo && isRegInfoModal}
                setIsOpen={setRegInfoModal}
                eventSlug={eventSlug}
                requestData={requestData}
                is_approved={isApproved}
                canDelete={canDelete}
            />
        </>
    )
}
